import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { BehaviorSubject, Subscription, switchMap, take, tap } from 'rxjs';
import { ContentPageGridService } from '../content-page-grid/core/content-page-grid.service';
import { Page, PaginationModel } from '@spartacus/core';
import { ToolsService } from '../../../../../../core/services/tools.service';
import { DEVICE_SIZE } from '../../../../../../core/models/others.model';

@Component({
  selector: 'page-grid-container',
  templateUrl: './page-grid-container.component.html',
  styleUrl: './page-grid-container.component.scss',
  standalone: false,
})
export class PageGridContainerComponent implements OnInit, OnDestroy {
  @HostBinding('class.page-grid-container') isActive = true;

  DEVICE_SIZE = DEVICE_SIZE;
  allPages$ = new BehaviorSubject<Page[][]>([]);
  pages$ = new BehaviorSubject<Page[]>([]);
  pageIDS$ = new BehaviorSubject<string[]>([]);
  subscription = new Subscription();
  currentPage$ = new BehaviorSubject<number>(0);
  pagination$ = new BehaviorSubject<PaginationModel>({});
  component: any = {};
  itemPerLines: number = 3;
  itemPerPage: number = 16;
  isPristine$ = new BehaviorSubject<boolean>(true);

  constructor(
    private componentData: CmsComponentData<any>,
    private contentPageGridService: ContentPageGridService,
    private toolService: ToolsService,
  ) {}

  ngOnInit(): void {
    this.getContent();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getContent() {
    this.subscription.add(
      this.componentData.data$
        .pipe(
          take(1),
          tap(component => {
            this.component = component;
            this.itemPerPage = parseInt(this.component.itemPerPage) || 16;
            this.itemPerLines = parseInt(this.component.itemPerLines) || 4;
          }),
          switchMap(data => this.contentPageGridService.normalize(data)),
        )
        .subscribe(container => {
          const pages = [];

          for (let i = 0; i < (container.pages || []).length; i += this.itemPerPage) {
            pages.push((container.pages || []).slice(i, i + this.itemPerPage));
          }

          this.setPagination({
            currentPage: 0,
            pageSize: this.itemPerPage,
            totalPages: pages.length,
            totalResults: (container.pages || []).length,
          });

          this.allPages$.next(pages);
          this.pages$.next(pages[this.currentPage$.value]);
          this.isPristine$.next(false);
        }),
    );
  }

  getFlexBasis(): string {
    const curretSize = this.toolService.getCurrentSize();

    if (curretSize === DEVICE_SIZE.DESKTOP || curretSize === DEVICE_SIZE.WIDESCREEN) {
      const columnsPerRow: number = this.itemPerLines;
      const columnWidth = (100 / columnsPerRow).toFixed(2);
      const gap = 'calc(var(--cx-grid-col-gutter) * 2)';
      const columns = columnsPerRow;
      const flexBasis = `calc(${columnWidth}% - (${gap} * ((${columns} - 1) / ${columns})))`;

      return flexBasis;
    }

    return '';
  }

  setPagination(newPagnaition: Partial<PaginationModel>) {
    const pagination: PaginationModel = {
      currentPage: 0,
      pageSize: 0,
      sort: '',
      totalPages: 0,
      totalResults: 0,
    };

    this.pagination$.next({
      ...pagination,
      ...newPagnaition,
    });
  }

  pageChange(currentPage: number) {
    this.setPagination({
      ...this.pagination$.value,
      ...{
        currentPage,
      },
    });

    this.pages$.next(this.allPages$.value[currentPage]);
  }
}
